import { Component, DestroyRef, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { TestApi } from './shared/sdk';
import { catchError, EMPTY, Subject, takeUntil } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { ToastrModule } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, 
            HeaderComponent,
            FooterComponent,
            SidebarComponent,
          ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  protected readonly title = signal('pm-client');
  
  constructor(private destroyRef: DestroyRef,
              private testService: TestApi){}
  sayHello(){
    let lol = 'lolas';
    console.log(environment.apiBaseUrl);
    console.log(lol);

    this.testService.testControllerPublicEndpoint()
      .pipe(takeUntilDestroyed(this.destroyRef),
            catchError(err => {
              console.log(err);
              return EMPTY;
            }))
      .subscribe(res => {
        console.log(res);
      });
  }
}

